import { EmsInstance } from "@/instance/axios";
import { createMutationKeys, createQueryKeys } from "@lukemorales/query-key-factory";
import {
  FemsApiFemsCompareTariffPlanGetRequest,
  FemsApiFemsCompareTariffPlanVariableMaxPowerGetRequest,
  FemsApiFemsCompareTariffPlanVariableTotalEnergyGetRequest,
  FemsApiFemsCompareTariffShiftTotalEnergyPostRequest,
} from "@sizlcorp/sizl-api-document/dist/models";

export const compareTariffPlan = createQueryKeys("compareTariffPlan", {
  all: null,
  get: (params: FemsApiFemsCompareTariffPlanGetRequest) => {
    return {
      queryKey: [params],
      queryFn: () => EmsInstance.femsCompareTariffPlanGet(params),
    };
  },
  totalEnergy: (params: FemsApiFemsCompareTariffPlanVariableTotalEnergyGetRequest) => {
    return {
      queryKey: [params],
      queryFn: () => EmsInstance.femsCompareTariffPlanVariableTotalEnergyGet(params),
    };
  },
  maxPower: (params: FemsApiFemsCompareTariffPlanVariableMaxPowerGetRequest) => {
    return {
      queryKey: [params],
      queryFn: () => EmsInstance.femsCompareTariffPlanVariableMaxPowerGet(params),
    };
  },
});

export const mutateCompareTariffPlan = createMutationKeys("mutateCompareTariffPlan", {
  shiftEnergy: (params: FemsApiFemsCompareTariffShiftTotalEnergyPostRequest) => ({
    mutationKey: [params.femsCompareTariffShiftTotalEnergyPostRequest],
    mutationFn: () => EmsInstance.femsCompareTariffShiftTotalEnergyPost(params),
  }),
});
